import { SUPPORT_EMAIL } from "helpers/constants"
import "./style.scss"

function Error() {
  return <div className="components_error">
    <div>
      <h1>Oops!</h1>
      <h2>Sorry for the inconvenience &hellip;</h2>
      <p className="error-code">Error code: 500</p>
      <p>An error occurred, but it might help if you <a href=".">refresh the page</a>.</p>
      <p>If you need immediate assistance, please use the help widget at the bottom-right or send an email to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> to get in touch with us.</p>
      <p>We will have this resolved soon.</p>
    </div>
    <div>
      <img src="https://s3.amazonaws.com/pi-ompnt-nodejs/penguin.png" width="100%" />
    </div>
  </div>
}

export default Error
